module.exports = __webpack_public_path__ + "img/intelligence3.a505296f.png";